import request from '@/libs/request'

// 平台用户列表
export function agentOderList (data) {
  return request({
    url: `agentOrder/list`,
    method: 'get',
    params: data
  })
}
export function getSchool (data) {
  return request({
    url: `agentOrder/getSchool`,
    method: 'get',
    params: data
  })
}

